<template>
<div class="page page_settle">
    <div class="adress">
        <div class="info" v-if="selectAddress&&selectAddress.address_id">
            <div class="user">{{ selectAddress.address_person }} {{ selectAddress.address_phone }}</div>
            <div class="dizhi" @click="clickAdress">{{ selectAddress.address }}</div>
        </div>
        <div class="info" v-else>
            <div class="user">请选择收货地址</div>
        </div>
        <div class="icon_right" @click="clickAdress"></div>
    </div>
    <!-- 订单 -->
    <div class="order_wrap" v-if="info != null">
        <div class="order">
            <div class="order_top">
                <img v-if="info.tradesman" :src="info.tradesman.thumb ? ($publicData.withHttpStart(info.tradesman.thumb) ? info.tradesman.thumb : imageUrl+info.tradesman.thumb ) : $publicData.defaultTouxiang" alt="" class="thumb">
                <span class="shop_name" v-if="info.tradesman">{{ info.tradesman.nickname }}</span>
            </div>
            <div class="order_list">
                <div class="item clearfix">
                    <div class="item_l f-l">
						<van-image :src="info.attrShow ? imageUrl+info.attrShow[0] : $publicData.intangibleDefault" class="tu" fit="cover" />
                        <!-- <img :src="info.attrShow ? info.attrShow[0] : $publicData.intangibleDefault" alt="" class="tu"> -->
                    </div>
                    <div class="item_r f-l">
                        <div class="item_r_t">
                            <div class="title slh_s">{{ info.title }}</div>
                            <div class="sku slh_s">{{ info.descript }}</div>
                            <!-- <div class="sku slh_s">数量：{{ goods.good_nums }}</div> -->
                        </div>
						<div class="item_r_b">
							<div class="price"><span class="tag_cash">¥</span>{{ info.userprice ? info.userprice :info.price }}</div>
							<van-stepper v-model="dingzhiNums" integer min="1" :max="maxNums" @change="changeNums"/>
						</div>
                    </div>
                </div>
            </div>
            <!-- 是否自提 -->
            <!-- <div class="order_pro" v-if="ztpoint&&ztpoint.length>0">
                <div class="pro_l">是否自提</div>
                <div class="pro_r">
                    <van-radio-group v-model="ziti">
                        <van-radio :name="1" @click="clickZT(true)">
                            是
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon">
                            </template>
                        </van-radio>
                        <van-radio :name="0" @click="clickZT(false)">
                            否
                            <template #icon="props">
                                <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                            </template>
                        </van-radio>
                    </van-radio-group>
                </div>
            </div> -->
            <!-- 自提点 -->
            <!-- <van-radio-group v-model="item.selectzt" v-if="item.ziti">
                <van-cell-group class="cell_group">
                    <van-cell :border="false" clickable v-for="point in item.ztpoint" :key="point.zt_id" @click="item.selectzt = point.zt_id" class="order_pro">
                        <template #title>
                            <span class="custom-title pro_l">{{point.address}}</span>
                        </template>
                        <template #right-icon>
                            <van-radio :name="point.zt_id" class="pro_r">
                                <template #icon="props">
                                    <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                                </template>
                            </van-radio>
                        </template>
                    </van-cell>
                </van-cell-group>
            </van-radio-group> -->
            <!-- 邮费 -->
            <div class="order_pro youfei">
                <div class="pro_l">邮费</div>
				<!-- 定制品都是包邮的 2022年5月19日 -->
                <div class="pro_r">
                    <div class="normal">包邮</div>
                </div>
            </div>
            <!-- 折扣 只有b2c商品有折扣,b2b无折扣,is_platprice 为0是b2c商品-->
            <!-- <div class="order_pro youfei" v-if="discount && discount != 0 && item.is_platprice == 0">

<div class="pro_l">折扣</div>
                <div class="pro_r">
                    <div class="normal">{{ dazhe }}</div>
                </div>

</div> -->
            <!-- 填写备注 -->

        </div>
    </div>
    <!-- 折扣 -->
    <!-- <div class="quan_wrap discount" v-if="discount && discount != 0">
        <div class="quan">
            <div class="quan_l">折扣</div>
            <div class="quan_r">{{ dazhe }}</div>
        </div>
    </div> -->
    <!-- 优惠券 -->
    <div class="quan_wrap">
        <div class="quan">
            <div class="quan_l">优惠券</div>
            <div class="quan_r">无可用优惠</div>
        </div>
    </div>
    <div class="fuwu page_baocuo">
        <div class="filed">
            <div class="">备注</div>
            <van-field v-model="mark" type="textarea" rows="1" placeholder="请您填写备注信息..." />
        </div>
    </div>
    <!-- 立即购买 -->
    <div class="bottom tijiao">
        <div class="tijiao_l">
			<div class="">
				合计：<span class="price"><span class="tag_cash">¥</span>{{ allPrice }}</span>
			</div>
			<div class="" v-if="info.pay_type!=2">
				定金：<span class="price"><span class="tag_cash">¥</span>{{ depositPrice }}</span>
			</div>
		</div>
		<div class="tijiao_r" @click="toPay">{{info.pay_type==2?'支付全额':'支付定金'}}</div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN,
    SETTLE,
    SELECTADDRESS
} from "../../../.././vuex/mutation_types";
import Vue from 'vue';
import Bridge from '../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent

export default {
    // name: "map-index",
    data() {
        return {
            publicPath: process.env.BASE_URL,
            activeIcon: process.env.BASE_URL + './statics/images/active.png',
            inactiveIcon: process.env.BASE_URL + './statics/images/inactive.png',
            carts: {},
            allCount: 0,
            allPrice: 0,
            selectAddress: null,
            token: null,
            buy: null,
            imageUrl: this.$publicData.uploadImage,
            info: null,
            id: this.$route.query.id,
            type: this.$route.query.type, // 1商家发布 2用户发布
            ziti: 1,
            fare: null,
            addressFare: null,
            mark: null,
			ztpoint: null,
			made_deposit: null, // 订金比例, 比如35, 订金金额 = 总价(包括运费等)*made_deposit / 100
			depositPrice: null,
			dingzhiNums: 1, // 定制品数量 默认1
			maxNums: null // 剩余可定制量(总-已定制)
        };
    },
    components: {
        // PageSearch
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '结算'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                var params2 = {
                    'data': {
                        'key': 'selectAddress'
                    }
                }
                this.$bridge.callhandler('sdjy://public/getInfo', params2, (data2) => {
                    console.log('sdjy://public/getInfo')
                    console.log(params2)
                    console.log(data2)
                    if (data2.code == 200) {
                        var selectAddress = JSON.parse(data2.result.data)
                        if (selectAddress) {
                            this.selectAddress = selectAddress
							// 定制品都是包邮的 2022年5月19日
                            // this.getFare()
                        }
                        this.$bridge.callhandler('sdjy://public/removeInfo', params2, (data1) => {

                        })
                    }
                })
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
            this.getData()
        }
    },
    mounted() {
        var address = this.$store.getters.select_address
        if (address && address != undefined && address != '') {
            var selectAddress = JSON.parse(this.$store.getters.select_address)
            console.log('selectAddress=======', selectAddress)
            if (selectAddress) {
                this.selectAddress = selectAddress
				// 定制品都是包邮的 2022年5月19日
                // this.getFare()
                // this.$store.commit('REMOVEADDRESS');
            }
        } else {
			// console.log('mounted---',this.info)
			if(this.info){
				this.getTrandsmanInfo()
			}
        }
    },
    methods: {
        getData() {
            if (this.type == 1) {
                this.getDingzhiDetail()
            } else {
                this.getUserDingzhiDetail()
            }
			
        },
        getDingzhiDetail() {
            var that = this
            var params = {
                id: this.id,
                token: this.token
            }
            this.$api.dingzhi.detail(params).then(res => {
                if (res.code == 200) {
					that.info = res.result
					// 最大定制量
                    if (res.result.accept_order_count == 0) {
                        that.maxNums = 100
                    } else if((res.result.accept_order_count - res.result.order_count) > 0) {
						that.maxNums = res.result.accept_order_count - res.result.order_count
					} else {
						that.maxNums = 1
					}
                    that.getTrandsmanInfo()
                    that.setPrice()
                }
            })
        },
        getUserDingzhiDetail() {
            var params = {
                id: this.id,
                token: this.token
            }
            this.$api.dingzhi.comunitydetail(params).then(res => {
                if (res.code == 200) {
                    this.info = res.result
                    this.getTrandsmanInfo()
                    this.setPrice()
                }
            })
        },
        //获取匠人邮费、自提点
        getTrandsmanInfo() {
            console.log('getTrandsmanInfo - this.info:',this.info)
            var trade_uuid = ''
            if (this.type == 1) {
                trade_uuid = this.info.tradesman.uuid
            } else {
                trade_uuid = this.info.trasignup[0].tra_uuid
            }
            var params = {
                token: this.token,
                trade_uuid: trade_uuid
            }
            this.$api.dingzhi.fare(params).then(res => {
                if (res.code == 200) {
                    this.ztpoint = res.result.ztpoin
					this.made_deposit = res.result.config.made_deposit
                    if (res.result.fare && res.result.fare.length > 0) {
                        this.fare = res.result.fare[0]
                    }
                    this.getAddressData()
                    this.setPrice()
                }
            })
        },
        getAddressData() {
            // if (this.selectAddress) {
            //     return
			// }
            console.log('getAddressData-----',)
            var params = {
                token: this.token,
                page: 1,
                size: 30
            }
            console.log(params)
            this.$api.address.addressList(params).then(res => {
                if (res.code == 200) {
                    var list = res.result
					if(!this.selectAddress){
						for (let i = 0; i < list.length; i++) {
							const item = list[i];
							if (i == 0) {
								var data = {
									'address_id': item.address_id,
									'address_person': item.person,
									'address_phone': item.phone,
									'address': item.area_name1 + item.area_name2 + item.area_name3 + item.address,
									'is_default': item.default
								}
								this.selectAddress = data
							}
							if (item.default) {
								var data = {
									'address_id': item.address_id,
									'address_person': item.person,
									'address_phone': item.phone,
									'address': item.area_name1 + item.area_name2 + item.area_name3 + item.address,
									'is_default': item.default
								}
								this.selectAddress = data
							}
						}
					}                    
					// console.log('this.selectAddress',this.selectAddress)
                    if (this.selectAddress) {
						// 定制品都是包邮的 2022年5月19日
                        // this.getFare()
                    } else {
                        this.setPrice()
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //获取邮费(定制品都是包邮的 2022年5月19日; 不再计算邮费)
        getFare() {
            if (!this.selectAddress) {
                return
            }
            if (!this.info) {
                return
            }
            var trads = this.info.trasignup ? [this.info.trasignup[0].tra_id] : []
            console.log(trads)
            if (trads.length <= 0) {
                return
            }
            var params = {
                token: this.token,
                address_id: this.selectAddress.address_id,
                tradesman_id: trads
            };
            this.$api.shop.fare(params).then((res) => {
                if (res.code == 200) {
                    var addressFare = res.result[this.info.tradesman.id]
                    console.log('addressFare:', addressFare)
                    if (addressFare != 0) {
                        this.addressFare = addressFare
                    } else {
                        this.addressFare = null
                    }
                    console.log('donedone:', this.fare)
                    this.setPrice()
                } else {
                    this.$toast(res.message);
                }
            });
        },
        //设置价格
        setPrice() {
            console.log('setPrice - this.info',this.info)
            var tradesPrice = this.info.userprice ? this.info.userprice : this.info.price;
            // console.log('this.fare',this.fare)
			// 定制品都是包邮的  2022年5月19日
            // if (this.fare) {
            //     if (this.fare.fare_type == 0) { //包邮
            //     } else if (this.fare.fare_type == 1) { //
            //         if (this.info.price < JSON.parse(this.fare.fare_money)) {
            //             if (this.fare != null && this.fare != undefined && this.fare != '') {
            //                 tradesPrice = parseFloat(tradesPrice) + JSON.parse(this.addressFare)
            //             } else {
            //                 tradesPrice = parseFloat(tradesPrice) + JSON.parse(this.fare.fare)
            //             }
            //         }
            //     } else if (this.fare.fare_type == 2) {
            //         if (this.addressFare != null && this.addressFare != undefined && this.addressFare != '') {
            //             tradesPrice = parseFloat(tradesPrice) + JSON.parse(this.addressFare)
            //         } else {
            //             tradesPrice = parseFloat(tradesPrice) + JSON.parse(this.fare.fare)
            //         }
            //     }
            // }
            console.log('tradesPrice', tradesPrice)
			this.allPrice = (parseFloat(tradesPrice) * this.dingzhiNums).toFixed(2)
			console.log('made_deposit',this.made_deposit)
			this.depositPrice = (((parseFloat(tradesPrice) * this.made_deposit) / 100) * this.dingzhiNums).toFixed(2)
        },
        //创建订单
        toPay() {
            // 如果没有地址 提示去添加地址
            if (!this.selectAddress || this.selectAddress.length == 0) {
                this.$toast('请先选择地址')
                return;
            }
            this.creatOrder()
        },
        creatOrder() {
            var trade_uuid = ''
            if (this.type == 1) {
                trade_uuid = this.info.tradesman.uuid
            } else {
                trade_uuid = this.info.trasignup[0].tra_uuid
            }
            var params = {
                token: this.token,
                trade_uuid: trade_uuid,
                address_id: this.selectAddress.address_id,
                // zts: zts,
                id: this.info.id,
                mark: this.mark,
				type: this.type,
				num: this.dingzhiNums
            }
            console.log(params)
            this.$api.dingzhi.createOrder(params).then(res => {
                if (res.code == 200) {
                    window.localStorage.setItem('createOrder',res.result.pay_order_num)
					var is_park = res.result.is_park == 1 ? 2 : 0  // 1 园区 0 非园区; 支付页面,园区标识是2
                    if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
                        var params = {
                            'data': {
                                'url': this.$publicData.clientUrl + '/shop/pay?orderId=' + res.result.pay_order_num + '&price=' + res.result.price + '&isPlatprice='+ is_park + '&type=made'+'&dingzhi_status=1'
                            }
                        }
                        this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

                        })
                    } else {
                        console.log(res.result)
                        this.$router.push({
                            path: '/shop/pay',
                            query: {
                                orderId: res.result.pay_order_num,
                                price: res.result.price,
                                isPlatprice: is_park,
								type: 'made',
                                is_chargecard: res.result.is_chargecard,
                                park_uuid: res.result.park_uuid,
								dingzhi_status: 1 // 1 待付定金, 2 待付尾款
                            }
                        })
                    }
                } else {
                    this.$toast(res.message)
                }
            })
        },
        //自提
        clickZT(ziti) {
            if (ziti) {
                this.ziti = 1
            } else {
                this.ziti = 0
            }
            this.setPrice()
        },
        // 收货地址
        clickAdress() {
            // if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //     var params = {
            //         'data': {
            //             'url': this.$publicData.clientUrl + '/user/adress?canSelect=1&addressId=' + (this.selectAddress&&this.selectAddress.address_id?this.selectAddress.address_id:'')
            //         }
            //     }
            //     this.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

            //     })
            // } else {
                this.$store.commit('REMOVEADDRESS');
                this.$router.push({
                    path: '/user/adress',
                    query: {
                        canSelect: 1,
                        addressId: (this.selectAddress && this.selectAddress.address_id) ? this.selectAddress.address_id : ''
                    }
                })
            // }
		},
		// 更改数量
		changeNums(){
			var that = this
			console.log('定制量',that.dingzhiNums)
			// 更新价格
			that.setPrice()
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/deep/.van-hairline--top-bottom::after,
.van-hairline-unset--top-bottom::after {
    border: 0 none;
}
.page_settle .order_list .item_l .tu{
	width: 2.47rem;
    height: 2.47rem;
}
.page_settle .order_list .item_l img {
    width: 2.47rem;
	height: 2.47rem;
	border-radius: .13rem;
}

.page_settle .quan_wrap {
    margin-bottom: 0;
}

.page_baocuo .filed {
    border-width: .0267rem;
}

.page_settle {
    padding-bottom: 2.4rem;
}
</style>
